import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, field } from '@simonbackx/simple-encoding';
import { PermissionLevel } from '@stamhoofd/types/PermissionLevel';
import { getPermissionLevelNumber } from './PermissionLevel.js';
import { PermissionRole } from './PermissionRole.js';
/**
 * @deprecated
 * Use resource types
 * Give access to a given resouce based by the roles of a user
 */
export class PermissionsByRole extends AutoEncoder {
    read = [];
    write = [];
    full = [];
    /**
     * Whetever a given user has access to the members in this group.
     */
    getRolePermissionLevel(role) {
        for (const r of this.full) {
            if (r.id === role.id) {
                return PermissionLevel.Full;
            }
        }
        for (const r of this.write) {
            if (r.id === role.id) {
                return PermissionLevel.Write;
            }
        }
        for (const r of this.read) {
            if (r.id === role.id) {
                return PermissionLevel.Read;
            }
        }
        return PermissionLevel.None;
    }
    roleHasAccess(role, level = PermissionLevel.Read) {
        return getPermissionLevelNumber(this.getRolePermissionLevel(role)) >= getPermissionLevelNumber(level);
    }
}
__decorate([
    field({ decoder: new ArrayDecoder(PermissionRole) })
], PermissionsByRole.prototype, "read", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(PermissionRole) })
], PermissionsByRole.prototype, "write", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(PermissionRole) })
], PermissionsByRole.prototype, "full", void 0);
//# sourceMappingURL=PermissionsByRole.js.map